<div fxLayout="column" [ngStyle]="{'max-height.px': innerHeight}" fxFlexFill>

    <mat-form-field appearance="fill" fxFlex>
        <mat-label>{{'eligibleCitiesComponent.search'|translate}}</mat-label>
        <input matInput (keyup)="filterCities($event)" placeholder="{{'eligibleCitiesComponent.placeolder'|translate}}">
        <mat-icon matSuffix class="dark-ico">location_city</mat-icon>
    </mat-form-field>

    <div class="scrolled" *ngIf="eligibleCities">

        <table mat-table [dataSource]="eligibleCities" class="full-w">

            <ng-container matColumnDef="postal_code">
                <th mat-header-cell *matHeaderCellDef> {{'eligibleCitiesComponent.postalCode'|translate}} </th>
                <td mat-cell *matCellDef="let zone">{{zone.postal_code}}</td>
            </ng-container>

            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef> {{'eligibleCitiesComponent.city'|translate}} </th>
                <td mat-cell *matCellDef="let zone">{{zone.name | capitalize}}</td>
            </ng-container>

            <ng-container matColumnDef="delivery_price">
                <th mat-header-cell *matHeaderCellDef> {{'eligibleCitiesComponent.costs'|translate}}  </th>
                <td mat-cell *matCellDef="let zone">
                    {{ (zone.delivery_price === 0) ? ("eligibleCitiesComponent.free"|translate ) : (zone.delivery_price | priceFilter) }}</td>
            </ng-container>

            <ng-container matColumnDef="offered_from">
                <th mat-header-cell *matHeaderCellDef> {{'eligibleCitiesComponent.freecosts'|translate}} </th>
                <td mat-cell *matCellDef="let zone">

                    <div  class="text-center full-w " style="font-size: 10px;">
                        {{(!zone.offered_from) ? ' --- ' : '>'+ (zone.offered_from | priceFilter) }}
                    </div>
                </td>
            </ng-container>

            <ng-container matColumnDef="map">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let zone">
                    <button mat-icon-button matTooltip="{{'tooltip.googlemap'|translate}}"
                        (click)="goGmap(zone.latitude, zone.longitude)" angulartics2On="click"
                        angularticsAction="showCityOnGoogleMap" angularticsCategory="order">
                        <mat-icon color="primary">place</mat-icon>
                    </button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

    </div>

    <div class="layout-padd">
        <button mat-stroked-button class="full-w layout-padd dark-ico" (click)="closeDial()" angulartics2On="click"
            angularticsAction="closeShippingPriceDial" angularticsCategory="order">
            <span class="mat-title">{{"dialogs.go-back" | translate}}</span>
        </button>
    </div>

</div>